import React from 'react'

import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { isSameDay, parseISO } from 'date-fns'

const ChangeFollowingEventsPopup = (props) => {
    const [typeOfEdit, setTypeOfEdit] = React.useState("this-event")

    const closeAndReset = () => {
        props.setOpen(false)
        setTypeOfEdit("this-event")
    }

    const submitAndReset = () => {
      if(props.loadingCover) {
      } else {
        props.editTheEvent(typeOfEdit)
        setTypeOfEdit("this-event")
      }
    }

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={props.setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 border-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => closeAndReset()}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      Edit Recurring Event
                    </Dialog.Title>
                    <div className="mt-2">
                      <div>
                        <fieldset onChange={(e) => setTypeOfEdit(e.target.value)} value={typeOfEdit} className="mt-4 border-none">
                          <legend className="sr-only">Notification method</legend>
                          <div className="space-y-4">
                              <div className="flex items-center">
                                <input
                                  id={'this-event'}
                                  name="notification-method"
                                  type="radio"
                                  value="this-event"
                                  defaultChecked
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label htmlFor={'this-event'} className="ml-3 block text-sm font-medium text-gray-700">
                                  This event
                                </label>
                              </div>
                              <div className="flex items-center">
                                <input
                                  id={'following-events'}
                                  name="notification-method"
                                  type="radio"
                                  value="following-events"
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label htmlFor={'following-events'} className="ml-3 block text-sm font-medium text-gray-700">
                                  This and following events
                                </label>
                              </div>
                              { isSameDay(parseISO(props.eventObjectToEdit.dateTime), parseISO(props.editedEventObjectsOriginalDate)) && props.eventObjectToEdit.isTheOriginalEvent &&
                                <div className="flex items-center">
                                  <input
                                    id={'all-events'}
                                    name="notification-method"
                                    type="radio"
                                    value="all-events"
                                    className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                  />
                                  <label htmlFor={'all-events'} className="ml-3 block text-sm font-medium text-gray-700">
                                    All events
                                  </label>
                                </div>
                              }
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => submitAndReset()}
                  >
                    Ok
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={() => closeAndReset()}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default ChangeFollowingEventsPopup